import { useEffect, useState } from "react";
import { ScriptStatus } from "./useScript.types";
const SCRIPT_CACHE = new Map();
const loadScript = (src) => {
    const cached = SCRIPT_CACHE.get(src);
    if (cached)
        return cached;
    const promise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        const onLoad = () => {
            cleanUp();
            resolve();
        };
        const onError = () => {
            cleanUp();
            SCRIPT_CACHE.delete(src);
            script.remove();
            reject(new Error("Could not mount new script element"));
        };
        const cleanUp = () => {
            script.removeEventListener("load", onLoad);
            script.removeEventListener("error", onError);
        };
        script.addEventListener("load", onLoad);
        script.addEventListener("error", onError);
        document.body.appendChild(script);
    });
    SCRIPT_CACHE.set(src, promise);
    return promise;
};
const useScript = (src) => {
    const [status, setStatus] = useState(ScriptStatus.Pending);
    useEffect(() => {
        let aborted = false;
        const onLoad = () => {
            if (aborted)
                return;
            setStatus(ScriptStatus.Loaded);
        };
        const onError = () => {
            if (aborted)
                return;
            setStatus(ScriptStatus.Failed);
        };
        loadScript(src).then(onLoad).catch(onError);
        return () => {
            aborted = true;
        };
    }, [src]);
    return status;
};
export { useScript };
//# sourceMappingURL=useScript.js.map